

import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Alert } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import PubSub from "pubsub-js";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ActiveandIncative = (props) => {

    const sectionActive = async (event) => {
        try {
            
        if (event.section_id) {
            var myBoolean = (event.isactive === true) ? false : true;
            const sectionRecord = {
                section_id: event.section_id,
                isactive: myBoolean
            }

            console.log('sectionRecord-->',sectionRecord);
           
            const responce = await schoolApi.updateSectionActiveRecord(sectionRecord);
           
            if (responce.success) {
                toast.success(responce.message);
                props.onHide();
                props.sectionRecords();
            }
        }

    } catch (error) {
        toast.error(error.response.data.message);       
    }
    }
    return (
        <Modal  {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered  >
            <Alert variant="danger" className="mb-0">
                <Alert.Heading>
                    {props?.parent?.isactive === true ? 'Confirm Inactive?' : props.title}
                </Alert.Heading>
                <hr />
                <p>{props?.parent?.isactive === true ? 'You are going to inactive the record. Are you sure?' : props.message}</p>
                <div className="d-flex justify-content-end">
                    {props.table === "section" && (<Button onClick={() => sectionActive(props?.parent)} variant="danger" className="mx-2" > Yes </Button>)}
                    <Button onClick={props.onHide} variant="light" className="text-"> No  </Button>
                </div>
            </Alert>
            <ToastContainer/>
        </Modal>
    );
}

export default ActiveandIncative
